<template>
    <div class="quick-chat-container">
        <div v-if="myself.isAdmin" class="chat-alert user-unavailable" :class="{'visible': !activity.available}"><h2>User Logged Out</h2><p>Close this chat and reinitiate when they are available.</p></div>
        <!-- <div v-if="myself.isAdmin" class="chat-alert user-inactive" :class="{'visible': activity.inactive}"><h2>User is inactive</h2></div> -->
        <Header
            v-if="displayHeader"
            :myself="myself"
            :other="other"
            :colors="colors"
            :hide-close-button="hideCloseButton"
            @onClose="onClose()"
            @onMinimize="onMinimize()"
        >
        <template #header>
            <slot name="header"></slot>
        </template>
        </Header>
        <MessageDisplay 
            :colors="colors" 
            :messages="messages"
            :load-more-messages="loadMoreMessages"
            :myself="myself"
            :other="other"
            :scroll-bottom="scrollBottom"
            :other-typing="otherTyping"
        />
        <MessageManager 
            :myself="myself"
            :colors="colors"
            @onMessageSubmit="onMessageSubmit"
            @onTyping="onTyping"
        />
    </div>
</template>

<script>
    import Header from './HeaderComponent.vue'
    import MessageDisplay from './MessageDisplay.vue'
    import MessageManager from './MessageManager.vue'

    export default {
        components: {
            Header,
            MessageDisplay,
            MessageManager
        },
        props: {
            activity: {
                type: Object,
                required: true,
            },
            other: {
                type: Object,
                required: true
            },
            messages: {
                type: Array,
                required: true
            },
            myself: {
                type: Object,
                required: true
            },
            colors: {
                type: Object,
                required: true
            },
            hideCloseButton: {
                type: Boolean,
                required: false,
                default: false
            },
            submitIconSize: {
                type: Number,
                required: false,
                default: 24
            },
            closeButtonIconSize: {
                type: String,
                required: false,
                default: "15px"
            },
            loadMoreMessages: {
                type: Function,
                required: false,
                default: null
            },
            scrollBottom:{
                type: Object,
                required: false,
                default: () => {
                    return {
                        messageSent: true,
                        messageReceived: false
                    }
                }
            },
            displayHeader: {
                type: Boolean,
                required: false,
                default: true
            },
            otherTyping: {
                type: Boolean,
                required: true,
                default: false
            }
        },
        methods: {
            onClose: function(){
                this.$emit("onClose")
            },
            onMinimize: function(){
                this.$emit("onMinimize")
            },
            onMessageSubmit: function(message){
                this.$emit("onMessageSubmit", message)
            },
            onTyping: function(value) {
                this.$emit('onTyping', value)
            }
        },
    }
</script>